<template>
  <Content nav="true" admin="false">
    <h1>Order Request Form</h1>
    <form class="pure-form pure-form-stacked">
      <fieldset>
        <legend>Contact Info</legend>
        <div class="pure-g">
          <div class="pure-u-1 pure-u-sm-1-2">
            <div class="pure-control-group">
              <label for="name">Name</label>
              <input v-model="order.contactInfo.name" id="name" type="text" placeholder="Name">
            </div>
            <div class="pure-control-group">
              <label for="email">Email</label>
              <input v-model="order.contactInfo.email" id="email" type="email" placeholder="Email">
            </div>
            <div class="pure-control-group">
              <label for="phone">Phone</label>
              <input v-model="order.contactInfo.phone" id="phone" type="number" placeholder="Phone">
            </div>
          </div>
          <div class="pure-u-1 pure-u-sm-1-2">
            <div class="pure-control-group">
              <fieldset class="pure-group">
                <label for="street">Address</label>
                <input
                  v-model="order.contactInfo.addressLine1"
                  id="street"
                  type="text"
                  placeholder="Street"
                >
                <input v-model="order.contactInfo.addressLine2" type="text" placeholder="Suite/Apt">
                <br>
                <div class="pure-g">
                  <div class="pure-u-1 pure-u-sm-1-3">
                    <input
                      v-model="order.contactInfo.city"
                      type="text"
                      placeholder="City"
                      class="medium"
                    >
                  </div>
                  <div class="pure-u-1 pure-u-sm-1-4">
                    <input v-model="order.contactInfo.state" type="text" placeholder="State">
                  </div>
                  <div class="pure-u-1 pure-u-sm-1-4">
                    <input v-model="order.contactInfo.zip" type="text" placeholder="Zip">
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Event Info</legend>
        <div class="pure-g">
          <div class="pure-u-1 pure-u-sm-1-2">
            <div class="pure-control-group">
              <label for="order.eventInfo.notes">Date</label>
              <datetime type="datetime" v-model="order.eventInfo.date"></datetime>
            </div>
          </div>
          <div class="pure-u-1 pure-u-sm-1-2">
            <div class="pure-control-group">
              <fieldset class="pure-group">
                <label for="street-event">Address</label>
                <button
                  class="pure-button button-xsmall"
                  @click.prevent="copyAddress"
                >Copy Contact Address</button>
                <input
                  v-model="order.eventInfo.addressLine1"
                  id="street-event"
                  type="text"
                  placeholder="Street"
                >
                <input v-model="order.eventInfo.addressLine2" type="text" placeholder="Suite/Apt">
                <br>
                <div class="pure-g">
                  <div class="pure-u-1 pure-u-sm-1-3">
                    <input
                      v-model="order.eventInfo.city"
                      type="text"
                      placeholder="City"
                      class="medium"
                    >
                  </div>
                  <div class="pure-u-1 pure-u-sm-1-4">
                    <input v-model="order.eventInfo.state" type="text" placeholder="State">
                  </div>
                  <div class="pure-u-1 pure-u-sm-1-4">
                    <input v-model="order.eventInfo.zip" type="text" placeholder="Zip">
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Order Info</legend>
        <div class="pure-g">
          <div class="pure-u-1 pure-u-sm-1-2">
            <div class="pure-controls">
              <label for="sugarCookies" class="pure-checkbox">
                <input v-model="order.orderInfo.sugarCookies" id="sugarCookies" type="checkbox">&nbsp; Sugar Cookies
              </label>
            </div>
            <div class="details" v-show="order.orderInfo.sugarCookies">
              <div class="pure-controls">
                <input
                  type="number"
                  placeholder="# dozen(s)"
                  class="short"
                  v-model="order.orderInfo.sugarCookiesDetails.numberOfDozens"
                >
              </div>
              <div class="pure-controls">
                <label
                  class="pure-radio"
                  v-for="detail in order.orderInfo.sugarCookiesDetails.cookieSizeOptions"
                  :key="detail"
                  :for="detail"
                >
                  <input
                    :id="detail"
                    type="radio"
                    name="order.orderInfo.sugarCookiesDetails.cookieSizeOptions"
                    :value="detail"
                    v-model="order.orderInfo.sugarCookiesDetails.cookieSize"
                    @change="validateCookieSizeOptions"
                  >
                  {{ detail }}
                </label>
              </div>
              <div class="pure-controls">
                <label
                  class="pure-radio"
                  v-for="detail in order.orderInfo.sugarCookiesDetails.styleOptions"
                  :key="detail"
                  :for="detail"
                >
                  <input
                    :id="detail"
                    type="radio"
                    name="order.orderInfo.sugarCookiesDetails.styleOptions"
                    :value="detail"
                    v-model="order.orderInfo.sugarCookiesDetails.style"
                    :disabled="cookieSizeIsMini"
                  >
                  {{ detail }}
                </label>
              </div>
            </div>
            <div class="pure-controls">
              <label for="macs" class="pure-checkbox">
                <input v-model="order.orderInfo.macs" id="macs" type="checkbox">&nbsp; Macs
              </label>
            </div>
            <div class="details" v-show="order.orderInfo.macs">
              <div class="pure-controls">
                <input
                  type="number"
                  placeholder="# dozen(s)"
                  class="short"
                  v-model="order.orderInfo.macsDetails.numberOfDozens"
                >
              </div>
              <div class="pure-controls">
                <label
                  class="pure-radio"
                  v-for="detail in order.orderInfo.macsDetails.styleOptions"
                  :key="detail"
                  :for="detail"
                >
                  <input
                    :id="detail"
                    type="radio"
                    name="order.orderInfo.macsDetails.styleOptions"
                    :value="detail"
                    v-model="order.orderInfo.macsDetails.style"
                  >
                  {{ detail }}
                </label>
              </div>
              <div class="pure-controls">
                <textarea v-model="order.orderInfo.macsDetails.notes" placeholder="Notes"></textarea>
              </div>
            </div>
            <div class="pure-controls">
              <label for="cupcakes" class="pure-checkbox">
                <input v-model="order.orderInfo.cupcakes" id="cupcakes" type="checkbox">&nbsp; Cupcakes
              </label>
            </div>
            <div class="details" v-show="order.orderInfo.cupcakes">
              <div class="pure-controls">
                <input
                  type="number"
                  placeholder="# dozen(s)"
                  class="short"
                  v-model="order.orderInfo.cupcakesDetails.numberOfDozens"
                >
              </div>
              <div class="pure-controls">
                <label
                  class="pure-radio"
                  v-for="detail in order.orderInfo.cupcakesDetails.styleOptions"
                  :key="detail"
                  :for="detail"
                >
                  <input
                    :id="detail"
                    type="radio"
                    name="order.orderInfo.cupcakesDetails.styleOptions"
                    :value="detail"
                    v-model="order.orderInfo.cupcakesDetails.style"
                  >
                  {{ detail }}
                </label>
              </div>
              <div class="pure-controls">
                <label>Decor</label>
                <label
                  class="pure-radio"
                  v-for="detail in order.orderInfo.cupcakesDetails.decorOptions"
                  :key="detail"
                  :for="detail"
                >
                  <input
                    :id="detail"
                    type="radio"
                    name="order.orderInfo.cupcakesDetails.decorOptions"
                    :value="detail"
                    v-model="order.orderInfo.cupcakesDetails.decor"
                  >
                  {{ detail }}
                </label>
              </div>
            </div>
            <div class="pure-controls">
              <label for="cakes" class="pure-checkbox">
                <input v-model="order.orderInfo.cakes" id="cakes" type="checkbox">&nbsp; Cakes
              </label>
            </div>
            <div class="details" v-show="order.orderInfo.cakes">
              <div class="pure-controls">
                <input
                  type="number"
                  placeholder="# of people"
                  class="short"
                  v-model="order.orderInfo.cakesDetails.numberOfPeople"
                >
              </div>
              <div class="pure-controls">
                <label
                  class="pure-radio"
                  v-for="detail in order.orderInfo.cakesDetails.styleOptions"
                  :key="detail"
                  :for="detail"
                >
                  <input
                    :id="detail"
                    type="radio"
                    name="order.orderInfo.cakesDetails.styleOptions"
                    :value="detail"
                    v-model="order.orderInfo.cakesDetails.style"
                  >
                  {{ detail }}
                </label>
              </div>
              <div class="pure-controls">
                <textarea
                  v-model="order.orderInfo.cakesDetails.requestsIdeas"
                  placeholder="Requests/Ideas"
                ></textarea>
              </div>
            </div>
            <div class="pure-controls">
              <label for="other" class="pure-checkbox">
                <input v-model="order.orderInfo.other" id="other" type="checkbox">&nbsp; Other
              </label>
            </div>
            <div class="details" v-show="order.orderInfo.other">
              <div class="pure-controls">
                <textarea v-model="order.orderInfo.otherDetails.notes" placeholder="Notes"></textarea>
              </div>
            </div>
          </div>
          <div class="pure-u-1 pure-u-sm-1-2">
            <div class="pure-control-group">
              <label for="order.orderInfo.specialRequests">Special Requests</label>
              <textarea
                v-model="order.orderInfo.specialRequests"
                id="order.orderInfo.specialRequests"
                placeholder="Special Requests"
              ></textarea>
            </div>
            <div class="pure-control-group">
              <label for="order.orderInfo.notes">Notes</label>
              <textarea
                v-model="order.orderInfo.notes"
                id="order.orderInfo.notes"
                placeholder="Notes"
              ></textarea>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Place Order Request</legend>
        <p>Thanks so much for submitting your order request!</p>
        <p>
          Degenerate Baker will respond within
          <strong>3 business days</strong> to confirm your order and suss out any further details.
          An invoice will then be sent to reserve your order.
        </p>
        <p>
          <em>Have a magnificent day!</em>
        </p>
        <div class="pure-control-group">
          <br>
          <button
            @click.prevent="placeOrder"
            :disabled="saving"
            class="pure-button button-xlarge place-order-button"
          >
            <font-awesome-icon icon="utensils-alt"/>&nbsp; Place Order Request
          </button>
        </div>
      </fieldset>
      <fieldset id="terms">
        <legend>Terms &amp; Conditions</legend>
        <p>
          A deposit of 50% or more of the total cost of the order confirms and holds a reservation.
          The deposit is refundable in full 30 or more days before the event minus a $25 transaction fee for consultation services rendered.
          The remainder of payment is due no later than 7 days before the event.
          Late or no payment is subject to cancellation.
          Late payments may result in substitutions or modifications to the original order.
          Cancellations received on or within 14 days of the event date may not be subject to a refund.
        </p>
        <p>Degenerate Baker reserves the right to exercise artistic license in order to guarantee the structural, visual, and creative integrity of a dessert structure.</p>
      </fieldset>
    </form>
  </Content>
</template>

<script>
import { Datetime } from 'vue-datetime'
import Moment from 'moment'

export default {
  name: 'Form',
  components: { datetime: Datetime, Moment },
  computed: {
    cookieSizeIsMini() {
      return this.order.orderInfo.sugarCookiesDetails.cookieSize === 'Mini 1-2"'
    }
  },
  data() {
    return {
      saving: false,
      order: {
        status: 'pending',
        submittedDate: Moment().format(),
        orderNotes: '',
        contactInfo: {
          name: null,
          email: null,
          phone: null,
          addressLine1: null,
          addressLine2: null,
          city: null,
          state: null,
          zip: null
        },
        eventInfo: {
          date: null,
          addressLine1: null,
          addressLine2: null,
          city: null,
          state: null,
          zip: null
        },
        orderInfo: {
          sugarCookies: false,
          sugarCookiesDetails: {
            numberOfDozens: null,
            style: 'Basic',
            styleOptions: ['Basic', 'Detailed', 'Elaborate'],
            cookieSize: 'Mini 1-2"',
            cookieSizeOptions: [
              'Mini 1-2"',
              'Small 2-3"',
              'Medium 3-4"',
              'Large 4"+'
            ]
          },
          macs: false,
          macsDetails: {
            numberOfDozens: null,
            style: 'Single Flavor',
            styleOptions: ['Single Flavor', 'Multiflavor'],
            notes: null
          },
          cupcakes: false,
          cupcakesDetails: {
            numberOfDozens: null,
            style:
              'Basic (chocolate/yellow/white cake, single flavor frosting)',
            styleOptions: [
              'Basic (chocolate/yellow/white cake, single flavor frosting)',
              'Signature (custom flavors)'
            ],
            decor: 'Simple/Chill',
            decorOptions: ['Simple/Chill', 'Glam', 'Epic']
          },
          cakes: false,
          cakesDetails: {
            numberOfPeople: null,
            style: 'Basic Celebration',
            styleOptions: ['Basic Celebration', 'Signature', 'Custom'],
            requestsIdeas: null
          },
          other: false,
          otherDetails: {
            notes: null
          },
          specialRequests: null,
          notes: null
        }
      }
    }
  },
  methods: {
    validateCookieSizeOptions() {
      if (this.cookieSizeIsMini) {
        this.order.orderInfo.sugarCookiesDetails.style = 'Basic'
      }
    },
    copyAddress() {
      this.order.eventInfo.addressLine1 = this.order.contactInfo.addressLine1
      this.order.eventInfo.addressLine2 = this.order.contactInfo.addressLine2
      this.order.eventInfo.city = this.order.contactInfo.city
      this.order.eventInfo.state = this.order.contactInfo.state
      this.order.eventInfo.zip = this.order.contactInfo.zip
    },
    placeOrder() {
      this.saving = true
      this.$database
        .collection('orders')
        .add(this.order)
        .then(() => {
          this.saving = false
          alert("Thank you for your order request. I'll be in touch.")
          this.$router.push({ name: 'gallery' })
        })
    }
  }
}
</script>

<style lang="less" scoped>
legend {
  font-size: 1.5em;
  font-weight: bold;
  font-family: 'Open Sans Condensed', sans-serif;
  padding-top: 1em;
}

label {
  font-weight: bold;
  font-size: 0.85em;

  &.pure-radio {
    display: inline-block;
    margin-right: 1em;
  }
}

.pure-control-group,
.pure-controls {
  margin-bottom: 1em;
}

.vdatetime {
  display: inline-block;
}

.place-order-button {
  font-weight: bold;
  font-family: 'Open Sans Condensed', sans-serif;
  color: white;
  border-radius: 4px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  background-color: #ea3623;
}

.details {
  border-left: 3px solid #dedede;
  margin-left: 4px;
  padding-left: 1em;
  font-size: 0.85em;
  margin-bottom: 1em;
}

input[type='text'],
input[type='email'],
input[type='number'],
datetime {
  width: 85%;
}

input.short {
  width: 30%;
}

input.medium {
  width: 89%;
}

textarea {
  height: 4em;
  width: 85%;
}

@media screen and (max-width: 35.5em) {
  .wide {
    width: 100%;
  }

  input[type='text'],
  input[type='email'],
  input[type='number'],
  textarea,
  input.short,
  input.medium {
    width: 100%;
  }
}

#terms {
  p {
    color: #333;
    font-size: 0.85em;
  }
}
</style>
